module.exports = __webpack_public_path__ + "img/cdmxq.74fded12.jpg";